<template>
  <v-form>
    <v-card class="pa-4">
      <v-layout align-center class="title green--text my-4">
        <span>Partilhar com</span>
        <v-divider class="green ml-3" />
      </v-layout>
      <CollegueInputNew
        :users="users"
        @updateSelectedUsers="updateSelectedUsers"
      />

      <v-card-actions>
        <v-btn color="success" @click="submitSharedLogs">{{
          $t('common.Submit')
        }}</v-btn>
        <v-btn color="error" depressed @click="close">
          {{ $t('common.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import CollegueInputNew from '@/views/Logbook/components/CollegueInputNew'
export default {
  props: {
    close: { type: Function, required: true },
    submitSharedLogs: { type: Function, required: true },
    users: { type: Array, default: () => [] }
  },
  components: {
    CollegueInputNew
  },
  computed: {
    selectedUsers: {
      get() {
        return this.users
      },
      set(users) {
        this.$emit('updateSelectedUsers', users)
      }
    }
  },
  methods: {
    updateSelectedUsers(selectedUsers) {
      this.selectedUsers = selectedUsers
    }
  }
}
</script>
